/* eslint @typescript-eslint/ban-types: 0 */
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

export const cleaningListQuery = gql`
    query CleaningList($propertyId: Int!) {
        cleaningList(propertyId: $propertyId) {
            id
            time
            note
            value
            paid
        }
    }
`;

export const cleaningQuery = gql`
    query CleaningList($id: ID) {
        cleaning(id: $id) {
            id
            time
            note
            value
            paid
        }
    }
`;

export const createCleaningQuery = gql`
    mutation CreateCleaning(
        $propertyId: Int!
        $time: String!
        $note: String!
        $value: Int!
        $paid: Boolean!
    ) {
        createCleaning(propertyId: $propertyId, time: $time, note: $note, value: $value, paid: $paid) {
            id
        }
    }
`;

export const updateCleaningQuery = gql`
    mutation UpdateCleaning(
        $id: ID!
        $time: String!
        $note: String!
        $value: Int!
        $paid: Boolean!
    ) {
        updateCleaning(
            id: $id
            time: $time
            note: $note
            value: $value
            paid: $paid
        ) {
            id
        }
    }
`;

const removeCleaningQuery = gql`
    mutation removeCleaning($id: ID!) {
        removeCleaning(id: $id)
    }
`;

export const useRemoveCleaningMutation = (propertyId?: number) =>
    useMutation<
        {},
        {
            id: string;
        }
    >(removeCleaningQuery, {
        refetchQueries: propertyId
            ? [{ query: cleaningListQuery, variables: { propertyId } }]
            : [],
    });
